export default class DurationInput
{
  private readonly inputHandler: EventListener;
  private readonly wrapper: HTMLElement;
  private readonly input: HTMLInputElement;
  private readonly output: HTMLOutputElement;
  private readonly datalists: Array<any>;

  constructor(wrapper: HTMLElement)
  {
    this.wrapper = wrapper;

    const input = this.wrapper.querySelector('input');
    if(input instanceof HTMLInputElement) {
      this.input = input;
    } else {
      throw new Error("Duration input not found");
    }

    const output = this.wrapper.querySelector('output');
    if(output instanceof HTMLOutputElement) {
      this.output = output;
    } else {
      throw new Error("Duration output not found");
    }

    this.inputHandler = this.handleInputEvent.bind(this);
    this.enable();
  }

  protected enable(): void
  {
    this.input.addEventListener('input', this.inputHandler, false);
    this.input.dispatchEvent(new Event('input'));
  }

  private handleInputEvent(event: Event): void
  {
    if(event.target == this.input) {
      this.wrapper.style.setProperty('--value',this.input.value);
      const label = this.input.list?.querySelector('datalist option[value="' + this.input.value + '"]')?.getAttribute('label') ?? '';
      this.output.innerHTML = label;
    }
  }

  public setResource(id: string): void
  {
    const slug = id.replace('resources/', '');
    const datalist = this.wrapper.querySelector('#pricelist-' + slug) as HTMLDataListElement | null;

    if(datalist) {
      this.input.setAttribute('list', datalist.id);
      const minDuration = datalist.children[0].getAttribute('value');
      this.input.setAttribute('min', minDuration ?? '1');
      this.input.dispatchEvent(new Event('input'));
    }
  }

  public getValue(): number
  {
    return parseInt(this.input.value);
  }
} 